import React from 'react';

import { FormCheck, FormCheckPropsT } from '../FormCheck';

export type CheckboxPropsT = Omit<FormCheckPropsT, 'type'>;

export type CheckboxT = React.FC<CheckboxPropsT>;

export const Checkbox: React.FC<CheckboxPropsT> = (props) => {
  return (
    <FormCheck
      {...props}
      aria-invalid={!!props.errorMessage}
      type="checkbox"
    />
  );
};
